var _ = { escape: require('lodash.escape') };
module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="cal--error"><h1>No Available Timeslots</h1><p>Unfortunately we were unable to find any available timeslots for the selected day. To go to the the first available timeslot&nbsp;<a href="#">click here.</a></p></div>';

}
return __p
};

/*
original source:

<div class="cal--error">
    <h1>No Available Timeslots</h1>
    <p>Unfortunately we were unable to find any available timeslots for the selected day. To go to the the first available timeslot&nbsp;<a href="#">click here.</a></p>
</div>

*/
